import { ListControl } from '../controls/list_control.js';
import { window } from '../window.js';

/**
 * Activities control.
 */
class ActivityListControl extends ListControl {
  constructor() {
    super();

    this.label = 'Activities';
    this.options = [
      'backpacking',
      'car camping',
      'canoeing',
      'kayaking',
      'RVing',
      'fishing',
      'bbq',
    ];
    this.balloon = `Please enter activities you plan to take. This is needed to generate a checklist.`;

    const conv = [['car camping', 'car-camping']];
    this.to = new Map(conv);
    this.from = new Map(conv.map(v => v.reverse()));
  }

  get value() {
    return this.valueAsArray.map(v => this.to.get(v) || v);
  }

  set value(val) {
    super.value = (val || []).map(v => this.from.get(v) || v).join(',');
  }
}

window.customElements.define('activity-list-control', ActivityListControl);

export { ActivityListControl };
